import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SKELETON_COUNT = 5

const OrderListItemSkeleton = () => (
  <Styles.ItemContainer>
    <Styles.Header>
      <Styles.HeaderLeft>
        <Skeleton variant="rounded" width={80} height={20} />
        <Skeleton variant="rounded" width={60} height={24} />
        <Skeleton variant="rounded" width={70} height={24} />
      </Styles.HeaderLeft>
      <Skeleton variant="rounded" width={175} height={34} />
    </Styles.Header>
    <Styles.DetailContainer>
      <Styles.DetailLine>
        <Skeleton variant="rounded" width={250} height={16} />
        <Skeleton variant="rounded" width={100} height={16} />
      </Styles.DetailLine>
      <Styles.DetailLine>
        <Skeleton variant="rounded" width={200} height={16} />
        <Skeleton variant="rounded" width={120} height={16} />
      </Styles.DetailLine>
    </Styles.DetailContainer>
  </Styles.ItemContainer>
)

const TransactionsListSkeleton = () => (
  <Styles.Container>
    {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
      <OrderListItemSkeleton key={index} />
    ))}
  </Styles.Container>
)

export default TransactionsListSkeleton
